import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]
  static values = {
    dismissUrl: String,
    scriptUrl: String,
    shown: Boolean,
    populated: Boolean
  }

  connect() {
    // Show modal on first visit if not already shown
    if (!this.shownValue) {
      this.showModal()
    }
  }

  // Admin trigger to simulate the modal
  simulate() {
    this.showModal()
  }

  showModal() {
    if (!this.hasModalTarget) return

    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  hideModal() {
    if (!this.hasModalTarget) return

    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  async continueToBoard() {
    await this.markAsShown()

    // If populated from outline, refresh to show the cards
    if (this.populatedValue) {
      window.location.reload()
    } else {
      this.hideModal()
    }
  }

  async skipToWriting() {
    await this.markAsShown()
    window.location.href = this.scriptUrlValue
  }

  async markAsShown() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      await fetch(this.dismissUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "X-Requested-With": "XMLHttpRequest"
        },
        credentials: "same-origin"
      })
    } catch (error) {
      console.error("Failed to dismiss intro:", error)
    }
  }
}
